/** @module FormulatedProduct/NewFoodSupplierItem */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/locale",
	"csi/table/New",
	"csi/xml",
	"./NewFoodSupplierItemMixin",
	"Apparel/DesignatedSupplierMixin"
], function(declare,_,locale,New,xml,NewFoodSupplierItemMixin,DesignatedSupplierMixin) {

	return declare([NewFoodSupplierItemMixin, DesignatedSupplierMixin], {
		bUpdateParent: false,

		/**
		 * @override
		 * Set the parent product and designated supplier on popup view
		 */
		onCreatePopup: function(view) {
			this.inherited(arguments);

			var product = this.m_cache.getParentOfType(this.getParent(), ["Food", "FormulatedMaterial"]);
			if (product) {
				// initialize designated supplier
				this.initializeDPSForQuotes(view, "Supplier", product);
				view.setProduct(product);
			}
		},

		/**
		 * @override
		 * Ensure that parent product is in the cache from either the ProductSource or ProductSourcing level
		 */
		onDependencyPaths: function(paths) {
			paths.push(xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT));
		},

		_canNavigate: function() {
			// summary: disable Save & Go since action can create multiple supplier items
			return false;
		},

		getStringParameters: function() {
			// summary: use return value as parameter to success message
			var supplierItemsCreatedCnt = 0;
			if (this.urlNewItems) {
				supplierItemsCreatedCnt = this.urlNewItems.length;
			}

			return [supplierItemsCreatedCnt.toString()];
		},

		postProcessSuccess: function() {
			this.widget.refreshData();
		}

	});
});
